import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=540d3a60&scoped=true&"
import script from "@/views/Users/Guardian/Dashboard.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Guardian/Dashboard.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Guardian/dashboard.scss?vue&type=style&index=0&id=540d3a60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540d3a60",
  null
  
)

export default component.exports